






















import Vue from "vue";
import { Form } from "element-ui";
import { saveOrUpdate } from "@/api/advert-space";

export default Vue.extend({
  name: "ResourceAddOrUpdate",
  data() {
    return {
      form: {
        spaceKey: "",
        name: ""
      },
      rules: {
        spaceKey: [{ required: true, message: "请输入spaceKey", trigger: "blur" }],
        name: [{ required: true, message: "请输入广告位名称", trigger: "blur" }]
      },
      typeList: [],
      dialogFormVisible: false
    };
  },
  methods: {
    add() {
      this.form = {
        spaceKey: "",
        name: ""
      };
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
      });
    },
    editor(row: any) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
      });
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(async (valid) => {
        if (valid) {
          const { data } = await saveOrUpdate(this.form);
          if (data.state === 1) {
            this.$message.success("保存成功");
            this.dialogFormVisible = false;
            this.$emit("ok");
          } else {
            this.$message.error(data.message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
});
